var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home_1",
    "data-name": "home 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.74,
    viewBox: "0 0 20 17.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.41 7.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.072,0V9.318H10.554V5.288a.64.64,0,0,0-.64-.64h-4.5a.64.64,0,0,0-.64.64v4.03h-3.5V0H0V9.957a.64.64,0,0,0,.64.64H5.416a.64.64,0,0,0,.64-.64V5.928h3.22v4.03a.64.64,0,0,0,.64.64h4.8a.64.64,0,0,0,.64-.64V0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M19.8,8.851,10.522.173a.64.64,0,0,0-.87,0L.207,8.847a.64.64,0,0,0,.866.942l9.009-8.277,8.842,8.273a.64.64,0,0,0,.874-.934Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconWhite);
export default __webpack_public_path__ + "static/media/home-icon-white.2d1fbcdc8ccd4ebcbddf89bcc3be7f26.svg";
export { ForwardRef as ReactComponent };